import { gettext } from '@eventbrite/i18n';

import React from 'react';

import {
    EventDetailsMainInner,
    EventDetailsSectionTitle,
} from '../EventDetails';
import type { LegacyDescription } from './types';

export const OldDescriptionBeforeStructuredContent = ({
    legacyDescription,
}: LegacyDescription) => {
    if (!legacyDescription) {
        return null;
    }

    return (
        <EventDetailsMainInner>
            <div className="old-description">
                <EventDetailsSectionTitle>
                    <h2>{gettext('Description')}</h2>
                </EventDetailsSectionTitle>
                <div className="eds-text-bm">
                    {/* Summary comes from an old creation flow */}
                    <div
                        className="eds-l-mar-top-3 description-items"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: legacyDescription }}
                    ></div>
                </div>
            </div>
        </EventDetailsMainInner>
    );
};
